import { takeEvery, fork, put, all, call } from 'redux-saga/effects';

//Account Redux states
import { RETURN_TASK } from './actionTypes';
import { returnTaskSuccessful, returnTaskFailed } from './actions';

// Include call API
import { getTasksAPI } from '../../../api/tasks';

const tasksAPI = getTasksAPI();

// Is user return successfull then direct plot user in redux.
function* returnTask({ payload: { task, user, inbound } }) {
  try {
    yield call(tasksAPI.returnPod, task.taskCode, user.token, inbound);
    // P01021-147: history.go() recargaba la página entera (perdiendo el filtro aplicado en la
    // tabla de tareas) — la página escucha loadingReturnTask y refresca solo el listado.
    yield put(returnTaskSuccessful('RETURN task correct'));
  } catch (error) {
    const errorMessage =
      typeof error === 'string' ? error : error.error || error.message || 'Error al devolver la tarea';
    yield put(returnTaskFailed(errorMessage));
  }
}

export function* watchTaskReturn() {
  yield takeEvery(RETURN_TASK, returnTask);
}

function* returnTaskSaga() {
  yield all([fork(watchTaskReturn)]);
}

export default returnTaskSaga;
